import React, { Component } from 'react';
import { connect } from 'react-redux';
import { StockModule, convertToStockItem, getStockColorClassName, getAccessories, getStockColorLabel } from '../../util';
import { combineStates, stockDispatcher, stockState, productState, siteSettingsState, screenSizeState } from '../../store';
import classNames from 'classnames';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';
import { BusyContainer } from '../BusyContainer';
import { Box } from '@mui/material';

export class ProductStockComponent extends Component {

  componentDidMount() {
    // if currentView is coming from ProductsViewer comp, don't call the func to reduce unnecessary api calls
    if (this.props.currentView !== 'ProductsViewer') {
      this.getMissingStocks(this.props);
    }
  }

  componentDidUpdate() {
    if (this.props.currentView !== 'ProductsViewer') {
      this.getMissingStocks(this.props);
    }
  }

  getMissingStocks(props) {
    const { stocks, product,siteSettings } = props;
    const productsToQuery = [];

    const items = [product];

    for (let item of items) {
      if (!stocks[item.name]) {
        productsToQuery.push(item);
      }

      if (item.configuration) {
        const accessories = getAccessories(item);

        for (let accessory of accessories) {
          if (!stocks[accessory]) {
            const accessoryProduct = this.props.products[accessory];
            accessoryProduct && Object.keys(accessoryProduct).length && productsToQuery.push(accessoryProduct);
          }
        }
      }
    }

    siteSettings?.stockModule && siteSettings?.stockModule!=0 && productsToQuery.length && this.props.getStocks( productsToQuery.map( convertToStockItem ) );
  }

  isLoading() {
    const { product, stocks } = this.props;
    const stock = stocks[product.name];
    return stock && stock.loading || false;
  }

  render() {
    const { siteSettings, product, stocks, fromCart, shortForm, layout,fromStock } = this.props;

    if (!StockModule.showStock(siteSettings.stockModule)) {
      return null;
    }
    const text = ""
    if(fromStock){
       const stock = siteSettings.stockModule==0?product.stock:stocks[product.name] || 0;
       const text = siteSettings.hideStockQuantity ? null :siteSettings.stockModule==0?stock>0?"常规库存":"": stock.quantity > 0 ? "常规库存" : "";
       return <>
       <span className="ellipsed hide-on-medium hide-on-small"></span>
       <span className=" ellipsed" >{ text } </span>
       </>;
      }
      else{
    const stock = stocks[product.name] || 0;
    const availability = stock.availability;

    let className = classNames("stock-container", getStockColorClassName( availability ), {"row-product-stock":layout && layout.className==="bold-font"} );
    className = fromCart && stock.quantity < product.amount ? 'quantity-exceeded-stock' : className;
    const text = siteSettings.hideStockQuantity ? null : stock.quantity > 0 ? stock.quantity+" PC" : 0+" PC";
    const stockLabel = getStockColorLabel( availability );

    const status = {Stock_Green:"Available", Stock_Red:"Not available", Stock_Yellow:"Not in stock"}
    // return <BusyContainer isBusy={ this.isLoading() }>
    //   <span className={ className } title={ translate( stockLabel ) }>
    //     <span className="ellipsed hide-on-medium hide-on-small"></span>
    //     <span className="product-code ellipsed" >{ text } </span>
    //   </span>
    // </BusyContainer>;
     return <div className='stock-box'>
     {this.props.screenSize.width>900?<span className={ className } title={ translate( stockLabel ) }>
      <Box className="stock-icon" border={1} sx={{height:"8px", width:"8px",minWidth:"8px", borderRadius:"56px"}}></Box>
       <span className="ellipsed hide-on-medium hide-on-small"></span>
       {!siteSettings.hideStockQuantity &&
        <span className="product-code ellipsed stock-availability" >
          <span className="stock">{ text }</span>
          <span className="availability">{status[stockLabel]}</span> 
       </span>}
     </span>:<div className='mobile-stock'>
     <span className='text'>{translate("Availability")}</span>
     <span className={ className } title={ translate( stockLabel ) }>
     <Box className="stock-icon" border={1} sx={{height:"8px", width:"8px",minWidth:"8px", borderRadius:"56px"}}></Box>
        <span className="ellipsed hide-on-medium hide-on-small"></span>
       {!siteSettings.hideStockQuantity &&
        <span className="product-code ellipsed stock-availability" >
        <span className="stock-quantity">{ text }</span></span>}
      </span></div>}
   </div>;
  }
}}

ProductStockComponent.propTypes = {
  getStocks: PropTypes.func.isRequired,
  fromCart: PropTypes.bool,
  stocks: PropTypes.shape({
    name: PropTypes.string.isRequired,
    availability: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired
  }),
  product: PropTypes.shape({
    configuration: PropTypes.shape({}),
    name: PropTypes.string
  }),
  productsState: PropTypes.shape({}),
  siteSettings: PropTypes.shape({
    stockModule: PropTypes.number.isRequired
  })
};

export const ProductStock = connect( combineStates( productState, stockState, siteSettingsState, screenSizeState ),
  stockDispatcher )( ProductStockComponent ); 
